import React from "react";
import styled from "styled-components";
import { Description } from "./typography";
import { r } from "../utils";
import checkImage from "../../assets/check.png";

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1.5rem 1rem;
  ${r("padding", "4rem 2rem", "4rem .5rem")};
`;

const Check = styled.img`
  height: 1rem;
  padding-top: .3rem;
  padding-bottom: .1rem;
  padding-right: .2rem;
`;

const Text = Description.extend`
  flex: 1;
  padding-bottom: 0;
  padding-left: .5rem;
  font-size: 1.0625rem;
`;

const Benefit = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export default ({ list = [] }) =>
  <Grid>
    {list.map(benefit =>
      <Benefit benefit={benefit}>
        <Check src={checkImage} />
        <Text>
          {benefit}
        </Text>
      </Benefit>
    )}
  </Grid>;



// WEBPACK FOOTER //
// ./src/components/BenefitGrid.js